import { Account, PageNotification, PageUsers } from "01Data/Account";
import { ProcessAccountSettingPage } from "04UserPages/02SettingPages/03AccountSettingPage/process";
import { ProcessNotificationSettingPage } from "04UserPages/02SettingPages/04PermissionSettingPage/process";
import { AndonData } from "./Andon";
import { Camera } from "./Camera";
import { Locations } from "./Locations";

export class UserData {
  public andon: AndonData = new AndonData();
  public locations: Locations = new Locations();
  public camera: Camera = new Camera();
  public pageUsers: PageUsers = new PageUsers();
  public pageNotification: PageNotification = new PageNotification();
  // ユーズケース
  public process: ProcessAccountSettingPage = new ProcessAccountSettingPage();
  public processNotification: ProcessNotificationSettingPage =
    new ProcessNotificationSettingPage();
  public state: "normal" | "autoUpdate" = "normal";

  public async Update(account: Account) {
    if (this.state === "autoUpdate") {
      this.andon.Update(account);
    }
  }
}
